import { render, staticRenderFns } from "./GGLoading.vue?vue&type=template&id=6bbcad00&scoped=true&"
import script from "./GGLoading.vue?vue&type=script&lang=js&"
export * from "./GGLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbcad00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bbcad00')) {
      api.createRecord('6bbcad00', component.options)
    } else {
      api.reload('6bbcad00', component.options)
    }
    module.hot.accept("./GGLoading.vue?vue&type=template&id=6bbcad00&scoped=true&", function () {
      api.rerender('6bbcad00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Global/GGLoading.vue"
export default component.exports